export const environment = {
    production: false,
    apiUrl: 'https://nochallenge.net/mainapp/public'
    // apiUrl: 'http://vipspmllaravelupdate.capl'
    // apiUrl: 'http://localhost/vipspmlaravelupdate/public'
};
